// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__J1187","actionBar":"styles_actionBar__26dOA"};